import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconRegularDelivery, IconRegularHouse, IconRegularStore, IconSolidPlane } from '@notino/react-styleguide';
import { DeliveryType } from '@notino/shared/definitions/types';
import { DeliveryDisallowedReasons, IDelivery } from '@containers/ProductListing/model';
import messages from '../../../../messages';
import { TimeText } from '../TimeText';
export { hasOneDeliveryTypeWithTwoOptions } from "./hasOneDeliveryTypeWithTwoOptions";
export { groupPossibleDeliveries } from "./groupPossibleDeliveries";
export const getIconByDelivery = (delivery: IDelivery, isAbTest: boolean): JSX.Element => {
  switch (true) {
    case delivery.delivery === DeliveryType.Personal:
      return <IconRegularStore />;
    case delivery.delivery === DeliveryType.AirTransport && !isAbTest:
      return <IconSolidPlane />;
    default:
      return isAbTest ? <IconRegularHouse /> : <IconRegularDelivery />;
  }
};
const disallowedReasonMessageKeyMapping = {
  [DeliveryDisallowedReasons.AirTransportDisallowed]: messages.deliveryDisallowed
};
export const getDeliveryDescription = (delivery: IDelivery) => {
  if (delivery.disallowedReason) {
    const messageDescriptor = disallowedReasonMessageKeyMapping[delivery.disallowedReason];
    if (messageDescriptor) {
      return <FormattedMessage {...messageDescriptor} />;
    }
  }
  return <TimeText date={delivery.date} from={delivery.dateFrom ?? undefined} to={delivery.dateTo ?? undefined} />;
};
export const parseThresholdTime = (timeStr: string): Date => {
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, seconds || 0, 0);
  return date;
};
export const shouldShowFreeShipping = (delivery: IDelivery, catalogId: string): boolean => {
  if (delivery.freeShipping) {
    return true;
  }
  if (delivery.limitedFreeShipping) {
    const catalogIdNumber = Number(catalogId);
    return delivery.limitedFreeShipping.includes(catalogIdNumber);
  }
  return false;
};